import headerTitle from '../../assets/images/headerTitle.png'
import twitterIcon from '../../assets/images/twitterIcon.png'
import discordIcon from '../../assets/images/discordIcon.png'
import instagramIcon from '../../assets/images/instagramIcon.png'
import { FooterLeft, FooterRight, FooterWrapper, ImgIcon } from './styles'

const Footer = () => {
    return (
        <FooterWrapper>
            <FooterLeft>
                <img src={headerTitle} width={231} height={57} />
                <h4>Terms of Service</h4>
                <h4>Privacy Police</h4>
            </FooterLeft>
            <FooterRight>
                <ImgIcon src={twitterIcon} />
                <ImgIcon src={discordIcon} />
                <ImgIcon src={instagramIcon} />

            </FooterRight>
        </FooterWrapper>
    )
};

export default Footer;